"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _addToBasket = require("./addToBasket");
Object.keys(_addToBasket).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addToBasket[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addToBasket[key];
    }
  });
});
var _cookies = require("./cookies");
Object.keys(_cookies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cookies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cookies[key];
    }
  });
});
var _isValidNovageSkincareConfiguration = require("./isValidNovageSkincareConfiguration");
Object.keys(_isValidNovageSkincareConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isValidNovageSkincareConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isValidNovageSkincareConfiguration[key];
    }
  });
});
var _mapShades = require("./mapShades");
Object.keys(_mapShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapShades[key];
    }
  });
});
var _openQueryParam = require("./openQueryParam");
Object.keys(_openQueryParam).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _openQueryParam[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _openQueryParam[key];
    }
  });
});
var _revieve = require("./revieve");
Object.keys(_revieve).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _revieve[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _revieve[key];
    }
  });
});
var _sendUserEvents = require("./sendUserEvents");
Object.keys(_sendUserEvents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendUserEvents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendUserEvents[key];
    }
  });
});